"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultSfilterPriceCustomOptionBuyUsd = exports.defaultSfilterPriceCustomOptionBuyHkd = exports.defaultSfilterPriceCustomOptionRentUsd = exports.defaultSfilterPriceCustomOptionRentHkd = void 0;
exports.defaultSfilterPriceCustomOptionRentHkd = {
    selectedFromIndex: 0,
    selectedToIndex: 14,
    from: [
        { value: 0 },
        { value: 25000 },
        { value: 40000 },
        { value: 55000 },
        { value: 60000 },
        { value: 70000 },
        { value: 80000 },
        { value: 100000 },
        { value: 200000 },
        { value: 300000 },
        { value: 400000 },
        { value: 500000 },
    ],
    to: [
        { value: 25000 },
        { value: 40000 },
        { value: 55000 },
        { value: 60000 },
        { value: 70000 },
        { value: 80000 },
        { value: 100000 },
        { value: 200000 },
        { value: 300000 },
        { value: 400000 },
        { value: 500000 },
        { value: 600000 },
        { value: 700000 },
        { value: 800000 },
        { value: 900000 },
        { value: 1000000 },
        { value: -1 },
    ],
};
exports.defaultSfilterPriceCustomOptionRentUsd = {
    selectedFromIndex: 0,
    selectedToIndex: 14,
    from: [
        { value: 0 },
        { value: 3000 },
        { value: 4000 },
        { value: 6000 },
        { value: 8000 },
        { value: 10000 },
        { value: 20000 },
        { value: 30000 },
        { value: 40000 },
        { value: 50000 },
    ],
    to: [
        { value: 3000 },
        { value: 4000 },
        { value: 6000 },
        { value: 8000 },
        { value: 10000 },
        { value: 20000 },
        { value: 30000 },
        { value: 40000 },
        { value: 50000 },
        { value: 60000 },
        { value: 70000 },
        { value: 80000 },
        { value: 90000 },
        { value: 100000 },
        { value: -1 },
    ],
};
exports.defaultSfilterPriceCustomOptionBuyHkd = {
    selectedFromIndex: 0,
    selectedToIndex: 17,
    from: [
        { value: 0 },
        { value: 4000000 },
        { value: 5000000 },
        { value: 6000000 },
        { value: 7000000 },
        { value: 8000000 },
        { value: 9000000 },
        { value: 10000000 },
        { value: 12000000 },
        { value: 16000000 },
        { value: 20000000 },
        { value: 25000000 },
        { value: 30000000 },
        { value: 35000000 },
        { value: 40000000 },
        { value: 50000000 },
        { value: 60000000 },
        { value: 70000000 },
        { value: 80000000 },
    ],
    to: [
        { value: 4000000 },
        { value: 5000000 },
        { value: 6000000 },
        { value: 7000000 },
        { value: 8000000 },
        { value: 9000000 },
        { value: 10000000 },
        { value: 12000000 },
        { value: 16000000 },
        { value: 20000000 },
        { value: 30000000 },
        { value: 40000000 },
        { value: 50000000 },
        { value: 60000000 },
        { value: 70000000 },
        { value: 80000000 },
        { value: 90000000 },
        { value: -1 },
    ],
};
exports.defaultSfilterPriceCustomOptionBuyUsd = {
    selectedFromIndex: 0,
    selectedToIndex: 17,
    from: [
        { value: 0 },
        { value: 400000 },
        { value: 500000 },
        { value: 600000 },
        { value: 700000 },
        { value: 800000 },
        { value: 900000 },
        { value: 1000000 },
        { value: 1200000 },
        { value: 1600000 },
        { value: 2000000 },
        { value: 2500000 },
        { value: 3000000 },
        { value: 3500000 },
        { value: 4000000 },
        { value: 5000000 },
        { value: 6000000 },
        { value: 7000000 },
        { value: 8000000 },
    ],
    to: [
        { value: 400000 },
        { value: 500000 },
        { value: 600000 },
        { value: 700000 },
        { value: 800000 },
        { value: 900000 },
        { value: 1000000 },
        { value: 1200000 },
        { value: 1600000 },
        { value: 2000000 },
        { value: 3000000 },
        { value: 4000000 },
        { value: 5000000 },
        { value: 6000000 },
        { value: 7000000 },
        { value: 8000000 },
        { value: 9000000 },
        { value: -1 },
    ],
};
